import Component from '../core/Component'

export default class Process extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            buttons: [],
            visuals: [],
            descriptions: [],
        }

        this.state = {
            current: 0,
        }
    }
    prepare() {
        this.ref.buttons.forEach((element) => element.addEventListener('click', this.handleClick))
    }

    handleClick = (event) => {
        event.preventDefault()

        const index = this.ref.buttons.indexOf(event.currentTarget)

        if (index > -1) {
            this.show(index)
        }
    }

    show(targetIndex) {
        this.ref.buttons.forEach((element, index) => {
            element.classList.toggle('is-active', index === targetIndex)
        })
        this.ref.visuals.forEach((element, index) => {
            element.classList.toggle('is-left', index < targetIndex)
            element.classList.toggle('is-active', index === targetIndex)
            element.classList.toggle('is-right', index > targetIndex)
            element.classList.toggle(
                'is-hidden',
                index !== this.state.current && index !== targetIndex,
            )
        })
        this.ref.descriptions.forEach((element, index) => {
            element.classList.toggle('is-active', index === targetIndex)
        })

        this.state.current = targetIndex
    }
}
